import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from '@narvar/nth-spinner';
import Icon from '../Icon';

export const StyledImageContainer = styled.div`
  width: 93px;
  height: 93px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 1.5rem;
`;

const StyledImageDiv = styled.div(({ styles: { opacity, backgroundImage } = {} }) => ({
  width: '100%',
  height: '100%',
  backgroundImage,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: '50% 50%',
  opacity: opacity || 'initial',
}));

const StyledIconContainer = styled.div`
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background-color: #dbdbdb;
  opacity: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  margin: 4px;

  &:hover {
    cursor: pointer;
  }
`;

export const SpinnerThumbnail = () => (
  <StyledImageContainer>
    <Spinner />
  </StyledImageContainer>
);

export const ImageThumbnail = ({ src, filename, onDelete }) => {
  const [isDeleteHover, setDeleteHover] = React.useState(false);
  return (
    <StyledImageContainer>
      <StyledImageDiv
        alt="Uploaded Image"
        src={src}
        aria-label={filename}
        data-testid="uploaded-image"
        styles={{ opacity: isDeleteHover && '75%', backgroundImage: `url("${src}")` }}
      />
      <StyledIconContainer
        onMouseEnter={() => setDeleteHover(true)}
        onMouseLeave={() => setDeleteHover(false)}
        onClick={onDelete}
      >
        <Icon.Close s={{ width: '9px' }} />
      </StyledIconContainer>
    </StyledImageContainer>
  );
};

ImageThumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};
